import Vue from "vue";
import Router from "vue-router";
const Defalut = () =>
  import(/* webpackChunkName: "Default" */ "../../layouts/default.vue");
// const Home = () => import(/* webpackChunkName: "Home" */ "../pages/Home.vue");
const Login = () =>
  import(/* webpackChunkName: "Login" */ "../pages/login/index.vue");
const getpassword = () =>
  import(
    /* webpackChunkName: "getpassword" */ "../pages/login/loginmore/getpassword.vue"
  );
const Learnoverview = () =>
  import(
    /* webpackChunkName: "Learnoverview" */ "../pages/Learnoverview/index.vue"
  );
const PartyCulture = () =>
  import(
    /* webpackChunkName: "PartyCulture" */ "../pages/partyCulture/index.vue"
  );
const enHome = () =>
  import(/* webpackChunkName: "enHome" */ "../pages/en/home/index.vue");
const enHome1 = () =>
  import(/* webpackChunkName: "enHome1" */ "../pages/en/activityText/index.vue");
const enHome2 = () =>
  import(/* webpackChunkName: "enHome2" */ "../pages/en/seeMore/index.vue");
const enHome3 = () =>
  import(/* webpackChunkName: "enHome3" */ "../pages/en/seeMore1/index.vue");
const enHome4 = () =>
  import(/* webpackChunkName: "enHome4" */ "../pages/en/new1/index.vue");
// const consult = () =>
//   import(/* webpackChunkName: "consult" */ "../pages/home/consult/index.vue");
const learning = () =>
  import(/* webpackChunkName: "learning" */ "../pages/learning/index.vue");
const learningLearningListLearningMore = () =>
  import(
    /* webpackChunkName: "learningLearningListLearningMore" */ "../pages/learning/learningList/learningMore.vue"
  );
const learningLearningListActives = () =>
  import(
    /* webpackChunkName: "learningLearningListActives" */ "../pages/learning/learningList/actives.vue"
  );
const learningLearningListActives1 = () =>
  import(
    /* webpackChunkName: "learningLearningListActives1" */ "../pages/learning/learningList/actives1.vue"
  );
const learningLearningListActives2 = () =>
  import(
    /* webpackChunkName: "learningLearningListActives2" */ "../pages/learning/learningList/actives2.vue"
  );
const learningLearningListResultMore = () =>
  import(
    /* webpackChunkName: "learningLearningListResultMore" */ "../pages/learning/learningList/resultMore.vue"
  );
const learningLearningListRegistration = () =>
  import(
    /* webpackChunkName: "learningLearningListRegistration" */ "../pages/learning/learningList/registration.vue"
  );
const learningLearningListTecDynamic = () =>
  import(
    /* webpackChunkName: "learningLearningListTecDynamic" */ "../pages/learning/learningList/tecDynamic.vue"
  );
const learningLearningListResultText = () =>
  import(
    /* webpackChunkName: "learningLearningListResultText" */ "../pages/learning/learningList/resultText.vue"
  );
const learningLearningListLearningText = () =>
  import(
    /* webpackChunkName: "learningLearningListLearningText" */ "../pages/learning/learningList/learningText.vue"
  );
const learningLearningListContentmeeting = () =>
  import(
    /* webpackChunkName: "learningLearningListContentmeeting" */ "../pages/learning/learningList/contentmeeting.vue"
  );
const youerself = () =>
  import(/* youerself: "contactUs" */ "../pages/youerself/index.vue");
const vip = () =>
  import(/* webpackChunkName: "vip" */ "../pages/vip/index.vue");
const vipVipmore = () =>
  import(/* webpackChunkName: "vipVipmore" */ "../pages/vip/vipmore/index.vue");
const vipVipmoreShare = () =>
  import(
    /* webpackChunkName: "vipVipmoreShare" */ "../pages/vip/vipmore/share.vue"
  );
const vipVipmoreDetails = () =>
  import(
    /* webpackChunkName: "vipVipmoreDetails" */ "../pages/vip/vipmore/details.vue"
  );
const vipVipmoreSelf = () =>
  import(
    /* webpackChunkName: "vipVipmoreSelf" */ "../pages/vip/vipmore/self.vue"
  );
const vipVipmoreRecommended = () =>
  import(
    /* webpackChunkName: "vipVipmoreRecommended" */ "../pages/vip/vipmore/recommended.vue"
  );
const learnJournal = () =>
  //webpackChunkName: "learnJournal" "../pages/learnJournal/index.vue"
  import(
    /* webpackChunkName: "learnJournal" */ "../pages/societyJournal/index.vue"
  );
const learnJournaLearnmore = () =>
  import(
    /* webpackChunkName: "learnJournaLearnmore" */ "../pages/learnJournal/learnmore/index.vue"
  );
const learnJournalLearnmoreAbstract = () =>
  import(
    /* webpackChunkName: "learnJournalLearnmoreAbstract" */ "../pages/learnJournal/learnmore/abstract.vue"
  );
const learnJournalLearnmoreAbstractPlantDrink = () =>
    import(
        /* webpackChunkName: "learnJournalLearnmoreAbstract" */ "../pages/learnJournal/learnmore/abstractPlantDrink.vue"
        );
const learnJournalLearnmoreLearnJournalText = () =>
  import(
    /* webpackChunkName: "learnJournalLearnmoreLearnJournalText" */ "../pages/learnJournal/learnmore/LearnJournalText.vue"
  );
const contactUs = () =>
  import(/* webpackChunkName: "contactUs" */ "../pages/contactUs/index.vue");
const register = () =>
  import(
    /* webpackChunkName: "register" */ "../pages/login/loginmore/index1.vue"
  );
const traininginstitution = () =>
  import(
    /* webpackChunkName: "traininginstitution" */ "../pages/furtherEducation/furthmore/plan.vue"
  );
// const traininginstitutionDetail = () =>
//   import(
//     /* webpackChunkName: "traininginstitution" */ "../pages/furtherEducation/furthmore/traininginstitutionDetail.vue"
//   );
const applyActivities = () =>
  import(
    /* webpackChunkName: "applyActivities" */ "../pages/home/homemore/applyActivities"
  );
const membership = () =>
  import(/* webpackChunkName: "membership" */ "../pages/membership/index.vue");
const introducePart = () =>
  import(
    /* webpackChunkName: "introducePart" */ "../pages/Learnoverview/introduce/introducePart.vue"
  );
const Constitution = () =>
  import(
    /* webpackChunkName: "Constitution" */ "../pages/Learnoverview/introduce/Constitution.vue"
  );
const Honor2 = () =>
  import(
    /* webpackChunkName: "Constitution" */ "../pages/Learnoverview/introduce/Honor2.vue"
  );
const council = () =>
  import(
    /* webpackChunkName: "council" */ "../pages/Learnoverview/introduce/council.vue"
  );
const council2 = () =>
  import(
    /* webpackChunkName: "council" */ "../pages/Learnoverview/introduce/council2.vue"
  );
const people = () =>
  import(
    /* webpackChunkName: "people" */ "../pages/Learnoverview/introduce/people.vue"
  );

const toPressSpokesman = () =>
  import(
    /* webpackChunkName: "toPressSpokesman" */ "../pages/Learnoverview/introduce/pressSpokesman.vue"
    );

const branch = () =>
  import(
    /* webpackChunkName: "branch" */ "../pages/Learnoverview/introduce/branch.vue"
  );
const agency = () =>
  import(
    /* webpackChunkName: "agency" */ "../pages/Learnoverview/introduce/agency.vue"
  );
  const honorMore = () =>
  import(
    /* webpackChunkName: "agency" */ "../pages/Learnoverview/introduce/honorMore.vue"
  );
const articleText = () =>
  import(
    /* webpackChunkName: "articleText" */ "../pages/partyCulture/inmore/articleText.vue"
  );
const partyHistory = () =>
  import(
    /* webpackChunkName: "partyHistory" */ "../pages/partyCulture/inmore/partyHistory.vue"
  );
const inmore = () =>
  import(
    /* webpackChunkName: "inmore" */ "../pages/partyCulture/inmore/index.vue"
  );
const partyHistoryInmore = () =>
  import(
    /* webpackChunkName: "partyHistoryInmore" */ "../pages/partyCulture/inmore/partyHistoryIndex.vue"
  );

//学会要闻详情
const newText = () =>
  import(
    /* webpackChunkName: "newText" */ "../pages/home/homemore/newText.vue"
  );
//首页轮播详情
const bannerDetail = () =>
  import(
    /* webpackChunkName: "bannerDetail" */ "../pages/home/homemore/bannerDetail.vue"
  );
//学会要闻更多homemore
const homemore = () =>
  import(/* webpackChunkName: "homemore" */ "../pages/home/homemore/index.vue");

//通知公告announceText
const announceText = () =>
  import(
    /* webpackChunkName: "announceText" */ "../pages/home/homemore/announceText.vue"
  );
//通知公告更多announcements
const announcements = () =>
  import(
    /* webpackChunkName: "announcements" */ "../pages/home/homemore/announcements.vue"
  );

//近期新闻rencentText
const rencentText = () =>
  import(
    /* webpackChunkName: "rencentText" */ "../pages/home/homemore/rencentText.vue"
  );
//近期新闻更多recentnews
const recentnews = () =>
  import(
    /* webpackChunkName: "recentnews" */ "../pages/home/homemore/recentnews.vue"
  );
// 品质评价
const qualityAppraisal = () =>
  import(
    /* webpackChunkName: "qualityAppraisal" */ "../pages/qualityAppraisal/qualityAppraisal.vue"
  );

const groupStandards = () =>
  import(
    /* webpackChunkName: "groupStandards" */ "../pages/groupStandards/groupStandards.vue"
  );
const ruralRevitalization = () =>
  import(
    /* webpackChunkName: "ruralRevitalization" */ "../pages/ruralRevitalization/ruralRevitalization.vue"
  );
const searchQuery = () =>
  import(
    /* webpackChunkName: "searchQuery" */ "../pages/ruralRevitalization/searchQuery.vue"
  );
const detailedText = () =>
  import(
    /* webpackChunkName: "articleText" */ "../pages/ruralRevitalization/detailedText.vue"
  );
const more = () =>
  import(
    /* webpackChunkName: "more" */ "../pages/ruralRevitalization/more.vue"
  );
const more2 = () =>
  import(
    /* webpackChunkName: "more2" */ "../pages/ruralRevitalization/more2.vue"
  );
const detailedText2 = () =>
  import(
    /* webpackChunkName: "detailedText2" */ "../pages/ruralRevitalization/detailedText2.vue"
  );
const applyServe2 = () =>
  import(
    /* webpackChunkName: "applyServe2" */ "../pages/ruralRevitalization/applyServe2.vue"
  );
const qualityDetailedText = () =>
  import(
    /* webpackChunkName: " qualityDetailedText" */ "../pages/qualityAppraisal/qualityDetailedText.vue"
  );
const qualityDetailedText2 = () =>
  import(
    /* webpackChunkName: " qualityDetailedText2" */ "../pages/qualityAppraisal/qualityDetailedText2.vue"
  );
const qualityMore = () =>
  import(
    /* webpackChunkName: " qualityMore" */ "../pages/qualityAppraisal/qualityMore.vue"
  );
const morePostStandards = () =>
  import(
    /* webpackChunkName: " qualityMore" */ "../pages/groupStandards/morePostStandards.vue"
  );
const groupStandardsPicture2 = () =>
  import(
    /* webpackChunkName: " qualityMore" */ "../pages/groupStandards/groupStandardsPicture2.vue"
  );
const teacherdetail = () =>
  import(
    /* webpackChunkName: " teacherdetail" */ "../pages/groupStandards/teacherdetail.vue"
  );
const qualityApply = () =>
  import(
    /* webpackChunkName: " qualityApply" */ "../pages/qualityAppraisal/qualityApply.vue"
  );
const getKnowledge = () =>
  import(
    /* webpackChunkName: " getKnowledge" */ "../pages/home/homemore/getKnowledge.vue"
  );
const getKnowledgeMore = () =>
  import(
    /* webpackChunkName: " getKnowledgeMore" */ "../pages/home/homemore/getKnowledgeMore.vue"
  );
const homeMorePostStandards = () =>
  import(
    /* webpackChunkName: " homeMorePostStandards" */ "../pages/home/homemore/homeMorePostStandards.vue"
  );
const homePostStandards = () =>
  import(
    /* webpackChunkName: " homePostStandards" */ "../pages/home/homemore/homePostStandards.vue"
  );
const qualityPostStandards = () =>
  import(
    /* webpackChunkName: " qualityPostStandards" */ "../pages/qualityAppraisal/qualityPostStandards.vue"
  );
const qualityMorePostStandards = () =>
  import(
    /* webpackChunkName: " qualityMorePostStandards" */ "../pages/qualityAppraisal/qualityMorePostStandards.vue"
  );
const informdetail = () =>
  import(
    /* webpackChunkName: " informdetail" */ "../pages/learnService/servicemore/informdetail.vue"
  );
const learnServicedetailedText1 = () =>
  import(
    /* webpackChunkName: " learnServicedetailedText1" */ "../pages/learnService/servicemore/learnServicedetailedText1.vue"
  );
const learnServiceMore1 = () =>
  import(
    /* webpackChunkName: " learnServiceMore1" */ "../pages/learnService/servicemore/learnServiceMore1.vue"
  );
const learnServiceApply1 = () =>
  import(
    /* webpackChunkName: " learnServiceApply1" */ "../pages/learnService/servicemore/learnServiceApply1.vue"
  );
const learnServiceApply2 = () =>
  import(
    /* webpackChunkName: " learnServiceApply2" */ "../pages/learnService/servicemore/learnServiceApply2.vue"
  );
const TeaResearchMore = () =>
  import(
    /* webpackChunkName: "  teaResearchMore" */ "../pages/learnService/servicemore/teaResearchMore.vue"
  );
const teaResearchDetailed = () =>
  import(
    /* webpackChunkName: "  teaResearchDetailed" */ "../pages/learnService/servicemore/teaResearchDetailed.vue"
  );
const meApplyDetailed = () =>
  import(
    /* webpackChunkName: "  meApplyDetailed" */ "../pages/furtherEducation/furthmore/meApplyDetailed.vue"
  );
/**
 * 科技普及 科普常识 更多
 */
// const technologyMore = () => {
//   import(
//     /* webpackChunkName: "technologyMore" */ "../pages/technology/techdefault/technologyMore.vue"
//   );
// };

/**
 * 科技普及 科普常识 更多
 */
// const technologyMore = () => {
//   import(
//     /* webpackChunkName: "technologyMore" */ "../pages/technology/techdefault/technologyMore.vue"
//   );
// };
/**
 * 科技普及 科普知识 详情
 */
// const learnServiceText = () => {
//   import("../pages/learnService/servicemore/learnServiceText");
// };


const activityText = () => {
  import(
  /* webpackChunkName: "announcements" */ "../pages/learning/learningList/activityText.vue");
};

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    { path: "/login", component: Login },
    { path: "/login/loginmore", component: register },
    { path: "/login/loginmore/getpassword", component: getpassword },
    {
      path: "/",
      component: Defalut,
      redirect: "/home",
      children: [
        {
          path: "/home",
          component: () =>
            import(/* webpackChunkName: "Home" */ "../pages/Home.vue")
        },
        {
          path: "/qualityAppraisal",
          component: () =>
            import("../pages/qualityAppraisal/qualityAppraisal.vue")
        },
        {
          path: "/groupStandards",
          component: () => import("../pages/groupStandards/groupStandards.vue")
        },
        {
          path: "/ruralRevitalization",
          component: () =>
            import("../pages/ruralRevitalization/ruralRevitalization.vue")
        },
        {
          path: "/ruralRevitalization/searchQuery",
          component: () =>
            import("../pages/ruralRevitalization/searchQuery.vue")
        },
        {
          path: "/ruralRevitalization/detailedText",
          component: () =>
            import("../pages/ruralRevitalization/detailedText.vue")
        },
        {
          path: "/ruralRevitalization/more",
          component: () => import("../pages/ruralRevitalization/more.vue")
        },
        {
          path: "/ruralRevitalization/more2",
          component: () => import("../pages/ruralRevitalization/more2.vue")
        },
        {
          path: "/ruralRevitalization/detailedText2",
          component: () =>
            import("../pages/ruralRevitalization/detailedText2.vue")
        },
        {
          path: "/ruralRevitalization/applyServe2",
          component: () =>
            import("../pages/ruralRevitalization/applyServe2.vue")
        },
        {
          path: "/qualityAppraisal/qualityDetailedText",
          component: () =>
            import("../pages/qualityAppraisal/qualityDetailedText.vue")
        },
        {
          path: "/qualityAppraisal/qualityDetailedText2",
          component: () =>
            import("../pages/qualityAppraisal/qualityDetailedText2.vue")
        },
        {
          path: "/groupStandards/groupStandardsPicture2",
          component: () =>
            import("../pages/groupStandards/groupStandardsPicture2.vue")
        },
        {
          path: "/groupStandards/teacherdetail",
          component: () => import("../pages/groupStandards/teacherdetail.vue")
        },
        {
          path: "/qualityAppraisal/qualityApply",
          component: () => import("../pages/qualityAppraisal/qualityApply.vue")
        },
        {
          path: "/home/homemore/getKnowledge",
          component: () => import("../pages/home/homemore/getKnowledge.vue")
        },
        {
          path: "/home/homemore/getKnowledgeMore",
          component: () => import("../pages/home/homemore/getKnowledgeMore.vue")
        },
        {
          path: "/home/homemore/homeMorePostStandards",
          component: () =>
            import("../pages/home/homemore/homeMorePostStandards.vue")
        },
        {
          path: "/home/homemore/homePostStandards",
          component: () =>
            import("../pages/home/homemore/homePostStandards.vue")
        },
        {
          path: "/qualityAppraisal/qualityPostStandards",
          component: () =>
            import("../pages/qualityAppraisal/qualityPostStandards.vue")
        },
        {
          path: "/qualityAppraisal/qualityMorePostStandards",
          component: () =>
            import("../pages/qualityAppraisal/qualityMorePostStandards.vue")
        },
        {
          path: "/learnService/servicemore/learnServiceMore1",
          component: () =>
            import("../pages/learnService/servicemore/learnServiceMore1.vue")
        },
        {
          path: "/learnService/servicemore/learnServicedetailedText1",
          component: () =>
            import(
              "../pages/learnService/servicemore/learnServicedetailedText1.vue"
            )
        },
        {
          path: "/learnService/servicemore/learnServiceApply1",
          component: () =>
            import("../pages/learnService/servicemore/learnServiceApply1.vue")
        },
        {
          path: "/learnService/servicemore/learnServiceApply2",
          component: () =>
            import("../pages/learnService/servicemore/learnServiceApply2.vue")
        },
        {
          path: "/learnService/servicemore/teaResearchMore",
          component: () =>
            import("../pages/learnService/servicemore/teaResearchMore.vue")
        },
        {
          path: "/learnService/servicemore/teaResearchDetailed",
          component: () =>
            import("../pages/learnService/servicemore/teaResearchDetailed.vue")
        },
        {
          path: "/furtherEducation/furthmore/meApplyDetailed/:id",
          component: () =>
            import("../pages/furtherEducation/furthmore/meApplyDetailed.vue")
        },
        // {
        //   path: "/groupStandards/groupStandardsMore",
        //   component: () =>
        //     import("../pages/groupStandards/groupStandardsMore.vue")
        // },
        // {
        //   path: "/groupStandards/groupStandardsText",
        //   component: () =>
        //     import("../pages/groupStandards/groupStandardsText.vue")
        // },
        {
          path: "/en/home",
          component: enHome
        },
        {
          path: "/en/activityText",
          component: enHome1
        },
        //ctss详情
        {
          path: "/en/seeMore",
          component: enHome2
        },
        //英文科普活动详情
        {
          path: "/en/seeMore1",
          component: enHome3
        },
        {
          path: "/en/new1",
          component: enHome4
        },
        //咨询
        // {
        //   path: "/home/consult",
        //   component: consult
        // },
        // 学会概况
        {
          path: "/learnoverview",
          component: Learnoverview
        },
        // 学会简介
        {
          path: "Learnoverview/introduce/introducePart",
          component: introducePart
        },
        {
          path: "qualityAppraisal/qualityMore",
          component: qualityMore
        },
        // 学会章程
        {
          path: "Learnoverview/introduce/Constitution",
          component: Constitution
        },
        // 学会荣誉
        {
          path: "Learnoverview/introduce/Honor2",
          component: Honor2
        },
        // 学会机构-理事会
        {
          path: "Learnoverview/introduce/council",
          component: council
        },
        // 学会机构-理事会
        {
          path: "Learnoverview/introduce/council2",
          component: council2
        },
        // 学会机构-监事会
        {
          path: "Learnoverview/introduce/people",
          component: people
        },
        // 学会机构-分支结构
        {
          path: "Learnoverview/introduce/branch",
          component: branch
        },
        // 荣誉-更多
        {
          path: "Learnoverview/introduce/honorMore",
          component: honorMore
        },
        // 学会机构-更多
        {
          path: "Learnoverview/introduce/agency",
          component: agency
        },
        // 学会机构-新闻发言人
        {
          path: "Learnoverview/introduce/pressSpokesman",
          component: toPressSpokesman
        },
        // 党建强会
        {
          path: "/partyCulture",
          component: PartyCulture
        },
        // 党建活动-详情
        {
          path: "/partyCulture/inmore/articleText",
          component: articleText
        },
        // 党建活动-更多
        {
          path: "/partyCulture/partyHistoryInmore",
          component: partyHistoryInmore
        },
        // 党史学习-详情
        {
          path: "/partyCulture/inmore/partyHistory",
          component: partyHistory
        },
        // 党史学习-更多
        {
          path: "/partyCulture/inmore",
          component: inmore
        },
        //学术交流
        {
          path: "/learning",
          component: learning
        },
        //通知通告
        {
          path: "/learning/learningList/learningMore",
          component: learningLearningListLearningMore
        },
        {
          path: "/learning/learningList/learningText",
          component: learningLearningListLearningText
        },
        //品牌活动
        {
          path: "/learning/learningList/actives",
          component: learningLearningListActives
        },
        {
          path: "/learning/learningList/actives1",
          component: learningLearningListActives1
        },
        {
          path: "/learning/learningList/actives2",
          component: learningLearningListActives2
        },
        //交流成果
        {
          path: "/learning/learningList/resultMore",
          component: learningLearningListResultMore
        },
        {
          path: "/learning/learningList/tecDynamic",
          component: learningLearningListTecDynamic
        },
        {
          path: "/learning/learningList/tecDynamic",
          component: learningLearningListTecDynamic
        },
        //学术会议
        {
          path: "/learning/learningList/resultText",
          component: learningLearningListResultText
        },
        //会议报名
        {
          path: "/learning/learningList/registration",
          component: learningLearningListRegistration
        },
        //会员之家
        {
          path: "/vip",
          component: vip
        },
        //会员须知
        {
          path: "/vip/vipmore",
          component: vipVipmore
        },
        //资源共享
        {
          path: "/vip/vipmore/share",
          component: vipVipmoreShare
        },
        //详情
        {
          path: "/vip/vipmore/details",
          component: vipVipmoreDetails
        },
        //推优荐优
        {
          path: "/vip/vipmore/recommended",
          component: vipVipmoreRecommended
        },
        //会员风采-个人
        {
          path: "/vip/vipmore/self",
          component: vipVipmoreSelf
        },
        //会员风采-团队
        {
          path: "/vip/vipmore/team",
          component: () =>
            import(
              /* webpackChunkName: "team" */ "../pages/vip/vipmore/team.vue"
            )
        },
        //学会期刊
        {
          path: "/learnJournal",
          component: learnJournal
        },
        //投稿说明
        {
          path: "/learnJournal/learnmore",
          component: learnJournaLearnmore
        },
        //近期摘要 茶叶科学
        {
          path: "/learnJournal/learnmore/abstract",
          component: learnJournalLearnmoreAbstract
        },
        //近期摘要 植物饮料
        {
          path: "/learnJournal/learnmore/abstractPlantDrink",
          component: learnJournalLearnmoreAbstractPlantDrink
        },
        //近期详情
        {
          path: "/learnJournal/learnmore/learnJournalText",
          component: learnJournalLearnmoreLearnJournalText
        },
        //联系我们
        {
          path: "/contactUs",
          component: contactUs
        },
        // 我的会议
        {
          path: "/youerself",
          component: youerself
        },
        /**
         * 科技普及
         */
        {
          path: "/technology",
          component: () =>
            import(
              /* webpackChunkName: "technology" */ "../pages/technology/index.vue"
            )
        },
        //科技普及--全民饮茶
        {
          path: "/technology/techdefault",
          component: () =>
            import(
              /* webpackChunkName: "techdefault" */ "../pages/technology/techdefault/index.vue"
            )
        },
        //科技普及--科普“四进”
        {
          path: "/technology/techdefault/quanternary",
          component: () =>
            import(
              /* webpackChunkName: "quanternary" */ "../pages/technology/techdefault/quanternary.vue"
            )
        },
        //科技普及--科普专家
        {
          path: "/technology/techdefault/sciencceteam",
          component: () =>
            import(
              /* webpackChunkName: "sciencceteam" */ "../pages/technology/techdefault/sciencceteam.vue"
            )
        },
        //科技普及--投稿入口
        {
          path: "/technology/techdefault/submittedEntry",
          component: () =>
            import(
              /* webpackChunkName: "submittedEntry" */ "../pages/technology/techdefault/submittedEntry.vue"
            )
        },

        /**
         * 科普常识 更多
         */
        {
          path: "/technology/techdefault/technologyMore",
          component: () =>
            import(
              /* webpackChunkName: "techdefault" */ "../pages/technology/techdefault/technologyMore.vue"
            )
        },
        {
          path: "/technology/techdefault/technologyText",
          component: () =>
            import(
              /* webpackChunkName: "techdefault" */ "../pages/technology/techdefault/technologyText.vue"
            )
        },
        {
          path: "/technology/techdefault/video",
          component: () =>
            import(
              /* webpackChunkName: "techdefault" */ "../pages/technology/techdefault/video.vue"
            )
        },
        {
          path: "/technology/techdefault/videodetail",
          component: () =>
            import(
              /* webpackChunkName: "techdefault" */ "../pages/technology/techdefault/videodetail.vue"
            )
        },
        {
          path: "/furtherEducation",
          component: () =>
            import(
              /* webpackChunkName: "furtherEducation" */ "../pages/furtherEducation/index.vue"
            )
        },
        {
          path: "/furtherEducation/searchQuery",
          component: () =>
            import(
              /* webpackChunkName: "searchQuery" */ "../pages/furtherEducation/searchQuery.vue"
            )
        },
        {
          path: "/furtherEducation/furthmore/textsum",
          component: () =>
            import(
              /* webpackChunkName: "furthmore" */ "../pages/furtherEducation/furthmore/textsum.vue"
            )
        },
        {
          path: "furtherEducation/furthmore/class1Text",
          component: () =>
            import(
              /* webpackChunkName: "furthmore" */ "../pages/furtherEducation/furthmore/class1Text.vue"
            )
        },
        {
          path: "/furtherEducation/furthmore/class2Text",
          component: () =>
            import(
              /* webpackChunkName: "furthmore" */ "../pages/furtherEducation/furthmore/class2Text.vue"
            )
        },
        {
          path: "/furtherEducation/furthmore/class3Text",
          component: () =>
            import(
              /* webpackChunkName: "furthmore" */ "../pages/furtherEducation/furthmore/class3Text.vue"
            )
        },
        {
          path: "/furtherEducation/furthmore/teacherclassDetails",
          component: () =>
            import(
              /* webpackChunkName: "furthmore" */
              "../pages/furtherEducation/furthmore/teacherclassDetails.vue"
            )
        },
        {
          path: "/furtherEducation/furthmore/furtherMore",
          component: () =>
            import(
              /* webpackChunkName: "furthmore" */ "../pages/furtherEducation/furthmore/furtherMore.vue"
            )
        },
        {
          path: "/furtherEducation/furthmore/furtherText",
          component: () =>
            import(
              /* webpackChunkName: "furthmore" */ "../pages/furtherEducation/furthmore/furtherText.vue"
            )
        },
        {
          path: "/furtherEducation/furthmore/branchs",
          component: () =>
            import(
              /* webpackChunkName: "furthmore" */ "../pages/furtherEducation/furthmore/branchs.vue"
            )
        },
        {
          path: "/furtherEducation/furthmore/crtificatequery",
          component: () =>
            import(
              /* webpackChunkName: "furthmore" */ "../pages/furtherEducation/furthmore/crtificatequery.vue"
            )
        },
        {
          path: "/furtherEducation/furthmore/academic",
          component: () =>
            import(
              /* webpackChunkName: "furthmore" */ "../pages/furtherEducation/furthmore/academic.vue"
            )
        },
        {
          path: "/furtherEducation/furthmore/teacherdetail",
          component: () =>
            import(
              /* webpackChunkName: "furthmore" */ "../pages/furtherEducation/furthmore/teacherdetail.vue"
            )
        },
        {
          path: "/furtherEducation/furthmore/students_good",
          component: () =>
            import(
              /* webpackChunkName: "furthmore" */ "../pages/furtherEducation/furthmore/students_good.vue"
            )
        },
        {
          path: "/furtherEducation/furthmore/studentsDetail",
          component: () =>
            import(
              /* webpackChunkName: "furthmore" */ "../pages/furtherEducation/furthmore/studentsDetail.vue"
            )
        },
        {
          path: "/furtherEducation/furthmore/mssageIteraction",
          component: () =>
            import(
              /* webpackChunkName: "furthmore" */ "../pages/furtherEducation/furthmore/mssageIteraction.vue"
            )
        },
        // 成绩查询
        {
          path: "/furtherEducation/furthmore/performance",
          component: () =>
            import(
              /* webpackChunkName: "performance" */ "../pages/furtherEducation/furthmore/performance.vue"
            )
        },
        // 课程试听
        {
          path: "/furtherEducation/furthmore/videodetail",
          component: () =>
            import(
              /* webpackChunkName: "videodetail" */ "../pages/furtherEducation/furthmore/videodetail.vue"
            )
        },
        {
          path: "/ideaBank",
          component: () =>
            import(
              /* webpackChunkName: "ideaBank" */ "../pages/ideaBank/index.vue"
            )
        },
        {
          path: "/ideaBank/moredetail/lookall",
          component: () =>
            import(
              /* webpackChunkName: "moredetail" */ "../pages/ideaBank/moredetail/lookall.vue"
            )
        },
        {
          path: "/groupStandards/groupStandardsMore",
          component: () =>
            import(
              /* webpackChunkName: "groupStandardsMore" */ "../pages/groupStandards/groupStandardsMore.vue"
            )
        },
        {
          path: "/groupStandards/groupStandardsText",
          component: () =>
            import(
              /* webpackChunkName: "groupStandardsText" */ "../pages/groupStandards/groupStandardsText.vue"
            )
        },
        {
          path: "/groupStandards/groupStandardsText2",
          component: () =>
            import(
              /* webpackChunkName: "groupStandardsText2" */ "../pages/groupStandards/groupStandardsText2.vue"
            )
        },
        {
          path: "/groupStandards/booksperiodicals",
          component: () =>
            import(
              /* webpackChunkName: "moredetail" */ "../pages/groupStandards/booksperiodicals.vue"
            )
        },
        {
          path: "/groupStandards/groupStandardsPicture",
          component: () =>
            import(
              /* webpackChunkName: "moredetail" */ "../pages/groupStandards/groupStandardsPicture.vue"
            )
        },
        // {
        //   path: "/ideaBank/moredetail/bookText",
        //   component: () =>
        //     import(
        //       /* webpackChunkName: "moredetail" */ "../pages/ideaBank/moredetail/bookText.vue"
        //     )
        // },
        {
          path: "/groupStandards/morePostStandards",
          component: () =>
            import(
              /* webpackChunkName: "moredetail" */ "../pages/groupStandards/morePostStandards.vue"
            )
        },
        {
          path: "/groupStandards/postStandards",
          component: () =>
            import(
              /* webpackChunkName: "moredetail" */ "../pages/groupStandards/postStandards.vue"
            )
        },
        {
          path: "/ideaBank/moredetail/ideaBankMore3",
          component: () =>
            import(
              /* webpackChunkName: "moredetail" */ "../pages/ideaBank/moredetail/ideaBankMore3.vue"
            )
        },
        {
          path: "/ideaBank/moredetail/ideaBankText3",
          component: () =>
            import(
              /* webpackChunkName: "moredetail" */ "../pages/ideaBank/moredetail/ideaBankText3.vue"
            )
        },
        {
          path: "learnService",
          component: () =>
            import(
              /* webpackChunkName: "learnService" */ "../pages/learnService/index.vue"
            )
        },
        // 应急技术服务
        {
          path: "learnService/servicemore",
          component: () =>
            import(
              /* webpackChunkName: "servicemore" */ "../pages/learnService/servicemore/index.vue"
            )
        },
        // 应急技术服务详情
        {
          path: "learnService/servicemore/emergencyDetail",
          component: () =>
            import(
              /* webpackChunkName: "servicemore" */ "../pages/learnService/servicemore/emergencyDetail.vue"
            )
        },

        //学会服务-精准扶贫 更多
        {
          path: "/learnService/servicemore/learnServiceMore",
          component: () =>
            import(
              /* webpackChunkName: "learnServiceMore" */ "../pages/learnService/servicemore/learnServiceMore.vue"
            )
        },
        //学会服务-精准扶贫 详情
        {
          path: "/learnService/servicemore/learnServiceText",
          component: () =>
            import(
              /* webpackChunkName: "learnServiceMore" */ "../pages/learnService/servicemore/learnServiceText.vue"
            )
        },
        //学会服务-定向服务 更多
        {
          path: "/learnService/servicemore/learnServiceMore2",
          component: () =>
            import(
              /* webpackChunkName: "learnServiceMore" */ "../pages/learnService/servicemore/learnServiceMore2.vue"
            )
        },
        //学会服务-定向服务 详情
        {
          path: "/learnService/servicemore/learnServiceText2",
          component: () =>
            import(
              /* webpackChunkName: "learnServiceMore" */ "../pages/learnService/servicemore/learnServiceText2.vue"
            )
        },
        //学会服务-产业资讯 更多
        {
          path: "/learnService/servicemore/learnServiceMore3",
          component: () =>
            import(
              /* webpackChunkName: "learnServiceMore" */ "../pages/learnService/servicemore/learnServiceMore3.vue"
            )
        },
        //学会服务-产业资讯 详情
        {
          path: "/learnService/servicemore/learnServiceText3",
          component: () =>
            import(
              /* webpackChunkName: "learnServiceMore" */ "../pages/learnService/servicemore/learnServiceText3.vue"
            )
        },
        //学会服务-应急技术服务 更多
        {
          path: "/learnService/servicemore/learnServiceMore4",
          component: () =>
            import(
              /* webpackChunkName: "learnServiceMore" */ "../pages/learnService/servicemore/learnServiceMore4.vue"
            )
        },
        //学会服务-应急技术服务 详情
        {
          path: "/learnService/servicemore/learnServiceText4",
          component: () =>
            import(
              /* webpackChunkName: "learnServiceMore" */ "../pages/learnService/servicemore/learnServiceText4.vue"
            )
        },
        //学会服务-茶叶品质评价 信息表
        {
          path: "/qualityAppraisal/evaluate",
          component: () =>
            import(
              /* webpackChunkName: "evaluate" */ "../pages/qualityAppraisal/evaluate.vue"
            )
        },
        //学会服务-茶叶品质评价 评价结果
        {
          path: "/qualityAppraisal/searchEvaluate",
          component: () =>
            import(
              /* webpackChunkName: "searchEvaluate" */ "../pages/qualityAppraisal/searchEvaluate.vue"
            )
        },
        //学会服务-茶叶品质评价 通知公告
        {
          path: "/qualityAppraisal/inform",
          component: () =>
            import(
              /* webpackChunkName: "inform" */ "../pages/qualityAppraisal/inform.vue"
            )
        },
        //学会服务-科技成果评价 通知公告
        {
          path: "/learnService/servicemore/announceMore",
          component: () =>
            import(
              /* webpackChunkName: "announceMore" */ "../pages/learnService/servicemore/announceMore.vue"
            )
        },
        //学会服务-科技成果评价 评价申请
        {
          path: "/learnService/servicemore/achievement",
          component: () =>
            import(
              /* webpackChunkName: "achievement" */ "../pages/learnService/servicemore/achievement.vue"
            )
        },
        //学会服务-科技成果评价 简讯
        {
          path: "/learnService/servicemore/newbrife",
          component: () =>
            import(
              /* webpackChunkName: "newbrife" */ "../pages/learnService/servicemore/newbrife.vue"
            )
        },
        //学会服务-团体标准制定 申请
        {
          path: "/groupStandards/teamStandard",
          component: () =>
            import(
              /* webpackChunkName: "teamStandard" */ "../pages/groupStandards/teamStandard.vue"
            )
        },
        //学会服务-团体标准制定 已发布的团体标准
        {
          path: "/groupStandards/teambefore",
          component: () =>
            import(
              /* webpackChunkName: "teambefore" */ "../pages/groupStandards/teambefore.vue"
            )
        },
        //学会服务-服务需求申请
        {
          path: "/learnService/servicemore/applyServe",
          component: () =>
            import(
              /* webpackChunkName: "applyServe" */ "../pages/learnService/servicemore/applyServe.vue"
            )
        },
        {
          path: "/learnService/servicemore/informdetail",
          component: () =>
            import(
              /* webpackChunkName: "informdetail" */ "../pages/learnService/servicemore/informdetail.vue"
            )
        },
        //继续教育 我要报名
        {
          path: "/furtherEducation/furthmore/furtherapply",
          component: () =>
            import(
              /* webpackChunkName: "furtherapply" */ "../pages/furtherEducation/furthmore/furtherapply.vue"
            )
        },
        //继续教育 我要参会
        {
          path: "/learning/learningList/detailMeeting",
          component: () =>
            import(
              /* webpackChunkName: "detailMeeting" */ "../pages/learning/learningList/detailMeeting.vue"
            )
        },
        //人才评价
        {
          path: "/talentAppraisal",
          component: () =>
            import(
              /* webpackChunkName: "talentAppraisal" */ "../pages/talentAppraisal/Index.vue"
            )
        },
        //人才评价 评价公告更多
        {
          path: "/talentAppraisal/announcementMore",
          component: () =>
            import(
              /* webpackChunkName: "announcementMore" */ "../pages/talentAppraisal/announcementMore.vue"
            )
        },
        //人才评价 评价公告详情
        {
          path: "/talentAppraisal/announcementText",
          component: () =>
            import(
              /* webpackChunkName: "announcementText" */ "../pages/talentAppraisal/announcementText.vue"
            )
        },
        //人才评价 评价新闻更多
        {
          path: "/talentAppraisal/newsMore",
          component: () =>
            import(
              /* webpackChunkName: "newsMore" */ "../pages/talentAppraisal/newsMore.vue"
            )
        },
        //人才评价 评价新闻详情
        {
          path: "/talentAppraisal/newsText",
          component: () =>
            import(
              /* webpackChunkName: "newsMore" */ "../pages/talentAppraisal/newsText.vue"
            )
        },
        //人才评价 在线报名
        {
          path: "/talentAppraisal/onlineRegistration",
          component: () =>
              import(
                  /* webpackChunkName: "newsMore" */ "../pages/talentAppraisal/onlineRegistration.vue"
                  )
        },
        // 直播会议列表
        {
          path: "/live/LiveList",
          component: () =>
            import(
              /* webpackChunkName: "LiveList" */ "../pages/live/LiveList.vue"
            )
        },
        // 直播会议列表详情
        {
          path: "/live/LiveListDetail",
          component: () =>
            import(
              /* webpackChunkName: "LiveListDetail" */ "../pages/live/LiveListDetail.vue"
            )
        },
        // 直播回放页面
        {
          path: "/live/Playback",
          component: () =>
            import(
              /* webpackChunkName: "Playback" */ "../pages/live/Playback.vue"
            )
        },
        // 培训报名
        {
          path: "/furtherEducation/furthmore/plan",
          component: traininginstitution
        },
        // 培训报名详情
        // {
        //   path: "/furtherEducation/furthmore/traininginstitutionDetail",
        //   component: traininginstitutionDetail
        // },
        // 活动申报
        {
          path: "/home/homemore/applyActivities",
          component: applyActivities
        },
        // 申请入会
        {
          path: "/membership",
          component: membership
        },
        //轮播详情
        {
          path: "/home/homemore/bannerDetail",
          component: bannerDetail
        },
        //学会要闻
        {
          path: "/home/homemore/newText",
          component: newText
        },
        //学会要闻更多homemore
        {
          path: "/home/homemore",
          component: homemore
        },
        //通知公告
        {
          path: "/home/homemore/announceText.vue",
          component: announceText
        },
        //通知公告更多announcements
        {
          path: "/home/homemore/announcements",
          component: announcements
        },
        //近期新闻rencentText
        {
          path: "/home/homemore/rencentText.vue",
          component: rencentText
        },
        //近期新闻更多recentnews
        {
          path: "/home/homemore/recentnews",
          component: recentnews
        },
        {
          path: "/home/qualityAppraisal/qualityAppraisal",
          component: qualityAppraisal
        },

        /* //
        {
          path: "/learning/learningList/activityText",
          component: activityText
        }, */
        //
        {
          path: "/learning/learningList/activityText",
          component: () =>
            import(
              /* webpackChunkName: "activityText" */ "../pages/learning/learningList/activityText.vue"
            )
        },
        //科普活动：国际茶日暨全民饮茶活动
        {
          path: "/technology/techdefault/activityText",
          component: () =>
              import(
                  /* webpackChunkName: "activityText2" */ "../pages/technology/techdefault/activityText.vue"
                  )
        },
        //科普活动：全民科学质素提升行动
        {
          path: "/technology/techdefault/activityText1",
          component: () =>
              import(
                  /* webpackChunkName: "activityText1" */ "../pages/technology/techdefault/activityText1.vue"
                  )
        },

        //学会期刊：跳转到茶叶科学详情页
        {
          path: "/learnJournal/learnmore/TeaScience",
          component: () =>
            import(
              /* webpackChunkName: "activityText1" */ "../pages//learnJournal/learnmore/TeaScience.vue"
              )
        },

        //学会期刊：跳转到植物饮料研究详情页
        {
          path: "/learnJournal/learnmore/BeveragePlantResearch",
          component: () =>
            import(
              /* webpackChunkName: "activityText1" */ "../pages//learnJournal/learnmore/BeveragePlantResearch.vue"
              )
        },

        //首页：点击 最上方的横幅图片 跳转到详情页
        {
          path: "/BannerHomeImg/index",
          component: () =>
            import(
              /* webpackChunkName: "BannerHomeImg" */ "../pages//BannerHomeImg/index.vue"
              )
        },

        //首页：点击 最上方的横幅图片[会议图片] 跳转到会议图片详情页
        {
          path: "/home/HomeMeetingDetails/index",
          component: () =>
            import(
              /* webpackChunkName: "HomeMeetingDetails" */ "../pages//home/HomeMeetingDetails/index.vue"
              )
        },
        //首页横幅后 咨询的详情

        //首页：点击 会议横幅 详情页 论文上传
        {
          path: "/learning/paperUpload/index",
          component: () =>
            import(
              /* webpackChunkName: "paperUpload" */ "../pages//learning/paperUpload/index.vue"
              )
        },
        //首页/横幅/咨询
        {
          path: "/home/consult/index",
          component: () =>
            import(
              /* webpackChunkName: "consult" */ "../pages/home/consult/index.vue"
              )
        },
        //首页/横幅/咨询/资讯列表
        {
          path: "/home/gengduo/index",
          component: () =>
            import(
              /* webpackChunkName: "gengduo" */ "../pages/home/gengduo/index.vue"
              )
        },
        //所有会议报名页面
        {
          path: "/learning/learningList/registration",
          component: () =>
            import(
              /* webpackChunkName: "learningList" */ "../pages/learning/learningList/registration.vue"
              )
        },

        //从首页年会报名按钮跳转到年会报名详情页
        {
          path: "/home/annualMeetingRegistration/index",
          component: () =>
            import(
              /* webpackChunkName: "annualMeetingRegistration" */ "../pages/home/annualMeetingRegistration/index.vue"
              )
        },

        //从首页年会报名按钮跳转到年会报名详情页
        {
          path: "/testLogin/index",
          component: () =>
            import(
              /* webpackChunkName: "annualMeetingRegistration" */ "../pages/testLogin/index.vue"
              )
        },

        //考试系统 登陆 点击开始考试
        {
          path: "/examTestPaper/index",
          component: () =>
            import(
              /* webpackChunkName: "examTestPager" */ "../pages/examTestPaper/index.vue"
              )
        },

        //学会概况-信息公开-学会年报/财务工作报告 跳转到学会年报/财务工作报告详情页
        {
          path: "/Learnoverview/introduce/report",
          component: () =>
            import(
              /* webpackChunkName: "examTestPager" */ "../pages/Learnoverview/introduce/report.vue"
              )
        },

      ]
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js